function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.613.22h-1.4v5.266h1.4V.22zm0 6.395h-1.4v1.504h1.4V6.615z",
  fill: "#fff"
});

var SvgIconLabelIncomplete = function SvgIconLabelIncomplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2 9",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMiA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuMzk5OSAwSDBWNS4yNjYxMUgxLjM5OTlWMFpNMS4zOTk5IDYuMzk0NTNIMFY3Ljg5OTE3SDEuMzk5OVY2LjM5NDUzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yMTI2NDYgMC4yMjAwOTMpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconLabelIncomplete as ReactComponent };